import { Injectable } from '@angular/core';
import { Driver } from './driver';
import { FileReaderService } from '../../app-commons/file-reader/file-reader.service';
import { map } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { MocksService } from '../../app-commons/mocks/mocks.service';
import { SpreadsheetService } from '../../ranking/results/spreadsheet.service';
import { Race } from '../../ranking/races/race';

@Injectable({
  providedIn: 'root'
})
export class DriversService {

  drivers: Driver[] = [];

  constructor(
    private fileReaderService: FileReaderService,
    private spreadsheetService: SpreadsheetService,
    private mocks: MocksService
  ) {
  }

  requestDrivers(race: Race, options?: any): Observable<Driver[]> {
    if (race.driversSpreadsheet) {
      return this.requestDriversSpreadsheet$(race.driversSpreadsheet, options);
    } else if (race.driversCsvFile) {
      return this.requestDriversCsv(race.driversCsvFile);
    } else {
      return EMPTY;
    }
  }

  requestDriversCsv(mockPath: string): Observable<Driver[]> {
    return this.mocks.get(mockPath).pipe(
      map(csvContent => this.parseCsv(csvContent))
    );
  }

  requestDriversSpreadsheet$(fileId: string, options?: any): Observable<Driver[]> {
    return this.spreadsheetService.poll(fileId, options).pipe(
      // filter(json => json && json.feed && json.feed.entry),
      // map(json => this.parseSpreadsheetJson(json.feed.entry))
      map(csv => this.parseCsv(csv)),
    );
  }

  findByEpc(epc: string): Driver | undefined {
    return this.drivers.find(driver => driver.epcs.includes(epc));
  }

  findByStartNumber(startNumber: number): Driver | undefined {
    return this.drivers.find(driver => driver.startNumber === startNumber);
  }

  setFromCsv(csvContent) {
    this.drivers = this.parseCsv(csvContent);
  }

  private parseCsv(data: string): Driver[] {
    const json = this.fileReaderService.parseCsv(data, ',', null, null, false);
    const headers = json.shift();
    const headersMap: any = {};
    headers.forEach((value, key) => headersMap[value] = key);

    return json.map(row => ({
      startNumber: +row[headersMap.number],
      name: row[headersMap.nick] || row[headersMap.name],
      epcs: [
        ...row[headersMap.EPC].replace(/\s+/, '').split(','),
        ...row[headersMap.EPC2]?.replace(/\s+/, '').split(',') || [],
        ...row[headersMap.EPC3]?.replace(/\s+/, '').split(',') || [],
        ...row[headersMap.EPC4]?.replace(/\s+/, '').split(',') || []
      ],
      model: headersMap.model ? row[headersMap.model] : '',
      category: +row[headersMap.category]
    } as Driver));
  }

  private parseSpreadsheetJson(entry: any[]): Driver[] {
    return entry.map(row => ({
      startNumber: +row.gsx$number.$t,
      name: row.gsx$nick.$t || row.gsx$name.$t,
      epcs: [
        ...row.gsx$epc.$t.replace(/\s+/, '').split(','),
        ...row.gsx$epc.$t?.replace(/\s+/, '').split(',') || [],
        ...row.gsx$epc.$t?.replace(/\s+/, '').split(',') || [],
        ...row.gsx$epc.$t?.replace(/\s+/, '').split(',') || []
      ],
      model: row.gsx$model && row.gsx$model.$t,
      category: +row.gsx$category.$t
    } as Driver));
  }
}
